export default "__VITE_ASSET__CZInJlFf__"